import { useEffect } from "react";
import { useNavigate } from "react-router-dom";
import LoginApi from "../api/LoginApi";
import useGlobalStore from "../stores/GlobalStore";

const useAuthCheck = () => {
    const navigate = useNavigate();
    const { setShowTokenExpired } = useGlobalStore();

    useEffect(() => {
        const checkLoginStatus = async () => {
            try {
                const res = await LoginApi.checkStatus();
                if (res.code ||
                    (res.data && !res.data.isAuthenticated)) {
                    setShowTokenExpired(true);
                }

            } catch (error) {
                console.error("檢查登入狀態時發生錯誤", error);
                setShowTokenExpired(true);
            }
        };

        checkLoginStatus();

        const interval = setInterval(checkLoginStatus, 1800000);

        return () => clearInterval(interval);
    }, [navigate]);


};

export default useAuthCheck;
